module.exports = __webpack_public_path__ + "Flag-442.1de1678264959ecfa469415b878a6c41.svg";